import React from 'react';

const MonthView = ({ curMonth, curYear, events, theme, onDaySelect, onEventSelect, renderDayContent, selectedDay }) => {
    const firstDay = new Date(curYear, curMonth-1, 1).getDay();
    const lastDay = new Date(curYear, curMonth, 0).getDate();

    const curMonthName = new Date(curYear, curMonth-1, 1).toLocaleString('default', { month: 'long' })
  
    // create an array of days in the month
    let numberofdays = 35;
    if (lastDay+firstDay > 35) { numberofdays = 42; }
    const daysOfMonth = Array.from({length: numberofdays}, (e,i) => i+1 );

    // Group days into weeks (array of arrays)
    const weeks = [];
    for (let i = 0; i < daysOfMonth.length; i += 7) {
        weeks.push(daysOfMonth.slice(i, i + 7));
    }

    const getDateForCell = (index) => new Date(curYear, curMonth-1, index-firstDay);

    const renderEvent = (event) => {
        const eventDate = new Date(event.startDate);
        return (
            <div
                key={event.id}
                onClick={(e) => {
                    e.stopPropagation();
                    onDaySelect(eventDate);
                    onEventSelect(event, e);
                }}
                className={`${theme.eventBg} ${theme.border} border rounded p-1 mb-1 text-xs cursor-pointer hover:shadow-md transition-shadow`}
            >
                <div className="font-medium truncate">{event.title}</div>
                <div className="text-xs opacity-75">
                    {new Date(event.startDate).toLocaleTimeString([], {hour:'2-digit',minute:'2-digit'})}
                </div>
            </div>
        );
    };

    return (
        <div className={`w-full h-full flex flex-col ${theme.gridBg} opacity-[.93]`} role="region" aria-label={`Calendar for ${curMonthName} ${curYear}`}>      

<div className="overflow-hidden px-4">
<div className={`grid grid-cols-7 grid-rows-1 h-10 ${theme.gridBg} divide-x divide-y ${theme.divider}`} role="grid" aria-label={`Days in ${curMonthName} ${curYear}`}> 
                    {/* Header row: day names */}
                    <div className={`flex h-10  align-middle justify-center font-bold ${theme.weekendHeaderBg} ${theme.dayNameText} p-2`} role="columnheader"><span className='hidden lg:block'>Sunday</span><span className='block lg:hidden'>S</span></div>
                    <div className={`flex h-10 align-middle justify-center font-bold ${theme.weekdayHeaderBg} ${theme.dayNameText} p-2`} role="columnheader"><span className='hidden lg:block'>Monday</span><span className='block lg:hidden'>M</span></div>
                    <div className={`flex h-10 align-middle justify-center font-bold ${theme.weekdayHeaderBg} ${theme.dayNameText} p-2`} role="columnheader"><span className='hidden lg:block'>Tuesday</span><span className='block lg:hidden'>T</span></div>
                    <div className={`flex h-10 align-middle justify-center font-bold ${theme.weekdayHeaderBg} ${theme.dayNameText} p-2`} role="columnheader"><span className='hidden lg:block'>Wednesday</span><span className='block lg:hidden'>W</span></div> 
                    <div className={`flex h-10 align-middle justify-center font-bold ${theme.weekdayHeaderBg} ${theme.dayNameText} p-2`} role="columnheader"><span className='hidden lg:block'>Thursday</span><span className='block lg:hidden'>T</span></div>
                    <div className={`flex h-10 align-middle justify-center font-bold ${theme.weekdayHeaderBg} ${theme.dayNameText} p-2`} role="columnheader"><span className='hidden lg:block'>Friday</span><span className='block lg:hidden'>F</span></div>    
                    <div className={`flex h-10 align-middle justify-center font-bold ${theme.weekendHeaderBg} ${theme.dayNameText} p-2`} role="columnheader"><span className='hidden lg:block'>Saturday</span><span className='block lg:hidden'>S</span></div>  
                    </div>
    </div>

            <div className="flex-1 overflow-hidden px-4 pb-4">
                <div className={`grid grid-cols-7 grid-rows-6 h-30 md:h-full ${theme.gridBg} divide-x divide-y ${theme.divider}`} role="grid" aria-label={`Days in ${curMonthName} ${curYear}`}> 
                    {/* Render weeks */}
                    {weeks.map((week, weekIdx) => (
                        <React.Fragment key={weekIdx}>
                            {/* 7 days of the week */}
                            {week.map((index, dayIdx) => {
                                if (index-firstDay < 1 || index-firstDay > lastDay) {
                                    return (               
                                        <div key={"blankday" + index + weekIdx} className={`flex align-middle justify-center p-2 border-b`} role="gridcell" aria-hidden="true">
                                        </div>
                                    )
                                } else {
                                    const thisDate = getDateForCell(index);
                                    const todayDate = new Date();
                                    const isToday = thisDate.toLocaleDateString() === todayDate.toLocaleDateString();
                                    const isSelected = selectedDay && thisDate.toLocaleDateString() === selectedDay.toLocaleDateString();
                                    
                                    let dayClasses = `align-middle justify-left opacity-100 transition-shadow duration-200 hover:z-10 hover:shadow-lg`;
                                    let todayBorder = '';
                                    if (isToday) {
                                        dayClasses += ` ${theme.todayBg}`;
                                        todayBorder = theme.todayBorder || (theme.isDark ? 'border-2 border-white' : 'border-2 border-gray-500'); 
                                    }
                                    if (isSelected && !isToday) {
                                        dayClasses += ' bg-blue-200 shadow-xl border-4 border-blue-600 z-10 relative';
                                    }
                                    else if (isSelected && isToday) {
                                        dayClasses += ' shadow-xl border-4 border-blue-600 z-10 relative';
                                    }
                                    if (!isSelected && !isToday) {
                                        dayClasses += ` ${theme.dayBg}`;
                                    }
                                    
                                    const thisDayEvents = events.filter(event => 
                                        event.startDate.split('T')[0] === thisDate.toISOString().split('T')[0]
                                    );
                                    const isFeaturedDay = thisDayEvents.some(event => event.eventType === 'Featured');

                                    return (
                                        <div 
                                            key={"day" + index + weekIdx} 
                                            className={`${dayClasses} flex flex-col h-20 md:h-full md:min-h-0 overflow-hidden`}
                                            role="gridcell"
                                            aria-label={`${thisDate.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}${thisDayEvents.length > 0 ? `, ${thisDayEvents.length} event${thisDayEvents.length > 1 ? 's' : ''}` : ''}`}
                                        >
                                            <p 
                                                onClick={() => onDaySelect(thisDate)} 
                                                className={`${isFeaturedDay ? theme.featuredDay : isToday ? todayBorder : theme.dayHeaderBg} font-medium items-center justify-center flex ${
                                                    window.innerWidth < 768 && thisDayEvents.length === 0 
                                                        ? 'cursor-not-allowed opacity-50' 
                                                        : 'cursor-pointer'
                                                }`}
                                            >
                                                <span className={`block w-8 h-6 rounded-full ${isToday ? theme.todayBackground : ''} ${thisDayEvents.length > 0 ? 'italic' : ''}`}>
                                                    {index-firstDay}
                                                    {thisDayEvents.length > 0 && (
                                                        <span className="hidden lg:inline text-xs opacity-75 ml-1">
                                                            ({thisDayEvents.length})
                                                        </span>
                                                    )}
                                                </span>
                                                <span className='block'>{isFeaturedDay && <i className={`text-xs fas fa-star ${theme.text}`} aria-hidden="true"></i>}</span>
                                            </p>
                                            {renderDayContent(thisDate, events)}
                                        </div>  
                                    )
                                }
                            })}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MonthView; 